
import React from "react";
import { Card, CardContent, CardDescription, CardFooter, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import DataLinkButton from "@/components/ui/data-link-button";
import { ForecastCardProps } from "./types";
import { createDataSource } from "./utils";

export function OperationalProjectCard({ model, onViewData }: ForecastCardProps) {
  return (
    <Card>
      <CardHeader className="flex flex-row items-start justify-between">
        <div>
          <CardTitle>{model.name}</CardTitle>
          <CardDescription>
            {model.startYear} - {model.endYear} | Operational
          </CardDescription>
        </div>
        <DataLinkButton 
          dataSource={createDataSource(model)}
          onViewData={onViewData}
        />
      </CardHeader>
      <CardContent>
        <div className="space-y-2">
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">NPV:</span>
            <span className="font-medium">${model.projectionData[model.projectionData.length - 1].npv.toLocaleString()}</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Mineral Price:</span>
            <span className="font-medium">${model.mineralPrice}/unit</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Discount Rate:</span>
            <span className="font-medium">{(model.discountRate * 100).toFixed(1)}%</span>
          </div>
          <div className="flex justify-between text-sm">
            <span className="text-muted-foreground">Peak Production:</span>
            <span className="font-medium">
              {Math.max(...model.projectionData.map(d => d.production)).toLocaleString()} units
            </span>
          </div>
        </div>
      </CardContent>
      <CardFooter>
        <Button variant="secondary" className="w-full">View Details</Button>
      </CardFooter>
    </Card>
  );
}
